// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    -webkit-animation: App-logo-spin infinite 20s linear;
            animation: App-logo-spin infinite 20s linear;
  }
}
body {
  font-family: "Mohave", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  background: rgb(0, 56, 56);
  background: linear-gradient(175deg, rgb(37, 37, 37) 50%, rgb(39, 39, 39) 100%);
  min-height: 100lvh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: calc(10px + 1vmin);
  color: white;
  overflow-x: hidden;
  --green: rgb(20, 116, 52);
  --red: rgb(183, 26, 26);
}
@media screen and (max-width: 720px) {
  body {
    font-size: 20px;
  }
}

.title {
  display: block;
  font-size: 2.5em;
  text-indent: -0.05em;
  padding-bottom: 16px;
  font-family: "Boogaloo", cursive;
  color: rgb(255, 255, 255);
  text-decoration: none;
  text-align: center;
}

label {
  padding: 25px 0 0;
  display: block;
}
label small {
  font-size: 0.6em;
}

.actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  width: 100%;
}
.actions .button,
.actions button {
  font-size: 1.1rem;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  padding: 5px 15px;
  text-align: center;
  margin: 0 5px;
  border: none;
  background: #f3f2f2;
  color: black;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  border-radius: 5px;
  -webkit-box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.15);
          box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.15);
  -webkit-transition: background 0.1s, -webkit-box-shadow 0.1s;
  transition: background 0.1s, -webkit-box-shadow 0.1s;
  transition: background 0.1s, box-shadow 0.1s;
  transition: background 0.1s, box-shadow 0.1s, -webkit-box-shadow 0.1s;
}
.actions .button[disabled],
.actions button[disabled] {
  background: rgba(255, 255, 255, 0.5);
  cursor: default;
}
.actions .button:first-child,
.actions button:first-child {
  margin-left: 0;
}
.actions .button:last-child,
.actions button:last-child {
  margin-right: 0;
}
.actions .button:not([disabled]):hover,
.actions button:not([disabled]):hover {
  background: rgba(255, 255, 255, 0.95);
  -webkit-box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.15);
          box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.15);
  padding-top: 6px;
  padding-bottom: 4px;
}
.actions .button:not([disabled]):active,
.actions button:not([disabled]):active {
  -webkit-box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.15);
          box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.15);
  padding-top: 8px;
  padding-bottom: 2px;
}
.actions .button.big,
.actions button.big {
  padding: 10px 15px;
}
.actions .button.big:not([disabled]):hover,
.actions button.big:not([disabled]):hover {
  padding-top: 12px;
  padding-bottom: 8px;
}
.actions .button.big:not([disabled]):active,
.actions button.big:not([disabled]):active {
  padding-top: 14px;
  padding-bottom: 6px;
}
.actions .button.dark,
.actions button.dark {
  background: hsla(180, 90%, 8%, 0.75);
  color: white;
}
.actions .button.dark[disabled],
.actions button.dark[disabled] {
  background: hsla(180, 75%, 40%, 0.75);
}
.actions .button.dark:not([disabled]):hover,
.actions button.dark:not([disabled]):hover {
  background: hsla(180, 88%, 14%, 0.6);
  -webkit-box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.5);
          box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.5);
}
.actions .button.dark:not([disabled]):active,
.actions button.dark:not([disabled]):active {
  -webkit-box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.5);
          box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.5);
}
.actions .button.outline,
.actions button.outline {
  background: hsla(180, 90%, 8%, 0);
  color: #e3e3e3;
  -webkit-box-shadow: 0 0 0 1px #e3e3e3;
          box-shadow: 0 0 0 1px #e3e3e3;
}
.actions .button.outline[disabled],
.actions button.outline[disabled] {
  color: rgba(227, 227, 227, 0.5);
  -webkit-box-shadow: 0 0 0 1px rgba(227, 227, 227, 0.5);
          box-shadow: 0 0 0 1px rgba(227, 227, 227, 0.5);
}
.actions .button.outline:not([disabled]):hover,
.actions button.outline:not([disabled]):hover {
  color: white;
  -webkit-box-shadow: 0 0 0 1px white;
          box-shadow: 0 0 0 1px white;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 5px 15px;
}
.actions .button.outline:not([disabled]):active,
.actions button.outline:not([disabled]):active {
  -webkit-box-shadow: 0 0 0 1px #e3e3e3;
          box-shadow: 0 0 0 1px #e3e3e3;
  background: rgba(255, 255, 255, 0.4);
}

.paper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 50px 50px 25px;
  -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.7490196078);
          box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.7490196078);
}
.paper.nopadding {
  padding: 0px;
}
.paper:before {
  display: block;
  position: absolute;
  content: "";
  background: rgba(30, 28, 32, 0.75);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: -1;
}

.col {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px;
}

.row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px;
}

.bottombar {
  background-color: rgb(22, 22, 22);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 6px 4px 4px;
  text-align: right;
}
.bottombar a {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 0.75em;
  color: white;
  margin: 0 12px;
}
.bottombar a:hover {
  color: rgb(105, 224, 145);
}
.bottombar a > * {
  margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE;IACE,oDAAA;YAAA,4CAAA;EACF;AACF;AAEA;EACE,yHAAA;EAGA,0BAAA;EACA,8EAAA;EAKA,kBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EAEA,yBAAA;EACA,uBAAA;AAPF;AASE;EAtBF;IAuBI,eAAA;EANF;AACF;;AASA;EACE,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AANF;;AASA;EACE,iBAAA;EACA,cAAA;AANF;AAQE;EACE,gBAAA;AANJ;;AAUA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,WAAA;AAPF;AASE;;EAEE,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,kBAAA;EACA,8DAAA;UAAA,sDAAA;EACA,4DAAA;EAAA,oDAAA;EAAA,4CAAA;EAAA,qEAAA;AAPJ;AASI;;EACE,oCAAA;EACA,eAAA;AANN;AASI;;EACE,cAAA;AANN;AASI;;EACE,eAAA;AANN;AASI;;EACE,qCAAA;EACA,6DAAA;UAAA,qDAAA;EACA,gBAAA;EACA,mBAAA;AANN;AASI;;EACE,6DAAA;UAAA,qDAAA;EACA,gBAAA;EACA,mBAAA;AANN;AASI;;EACE,kBAAA;AANN;AAQM;;EACE,iBAAA;EACA,mBAAA;AALR;AAQM;;EACE,iBAAA;EACA,mBAAA;AALR;AASI;;EACE,oCAAA;EACA,YAAA;AANN;AAQM;;EACE,qCAAA;AALR;AAQM;;EACE,oCAAA;EACA,4DAAA;UAAA,oDAAA;AALR;AAQM;;EACE,4DAAA;UAAA,oDAAA;AALR;AASI;;EACE,iCAAA;EACA,cAAA;EACA,qCAAA;UAAA,6BAAA;AANN;AAQM;;EACE,+BAAA;EACA,sDAAA;UAAA,8CAAA;AALR;AAQM;;EACE,YAAA;EACA,mCAAA;UAAA,2BAAA;EACA,0CAAA;EACA,iBAAA;AALR;AAQM;;EACE,qCAAA;UAAA,6BAAA;EACA,oCAAA;AALR;;AAWA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,kBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,uBAAA;EACA,+DAAA;UAAA,uDAAA;AARF;AAUE;EACE,YAAA;AARJ;AAWE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;AATJ;;AAaA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,mBAAA;MAAA,eAAA;EACA,SAAA;AAVF;;AAaA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,mBAAA;MAAA,eAAA;EACA,SAAA;AAVF;;AAaA;EACE,iCAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oBAAA;EACA,iBAAA;AAVF;AAYE;EACE,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;AAaI;EACE,iBAAA;AAXN","sourcesContent":["@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\nbody {\n  font-family: 'Mohave', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',\n    'Droid Sans', 'Helvetica Neue', sans-serif;\n\n  background: rgb(0, 56, 56);\n  background: linear-gradient(\n    175deg,\n    rgb(37, 37, 37) 50%,\n    rgb(39, 39, 39) 100%\n  );\n  min-height: 100lvh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 1vmin);\n  color: white;\n  overflow-x: hidden;\n\n  --green: rgb(20 116 52);\n  --red: rgb(183 26 26);\n\n  @media screen and (max-width: 720px) {\n    font-size: 20px;\n  }\n}\n\n.title {\n  display: block;\n  font-size: 2.5em;\n  text-indent: -0.05em;\n  padding-bottom: 16px;\n  font-family: 'Boogaloo', cursive;\n  color: rgb(255, 255, 255);\n  text-decoration: none;\n  text-align: center;\n}\n\nlabel {\n  padding: 25px 0 0;\n  display: block;\n\n  small {\n    font-size: 0.6em;\n  }\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  width: calc(100%);\n\n  .button,\n  button {\n    font-size: 1.1rem;\n    text-decoration: none;\n    white-space: nowrap;\n    cursor: pointer;\n    padding: 5px 15px;\n    text-align: center;\n    margin: 0 5px;\n    border: none;\n    background: #f3f2f2;\n    color: black;\n    flex: 1;\n    border-radius: 5px;\n    box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.15);\n    transition: background 0.1s, box-shadow 0.1s;\n\n    &[disabled] {\n      background: rgba(255, 255, 255, 0.5);\n      cursor: default;\n    }\n\n    &:first-child {\n      margin-left: 0;\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    &:not([disabled]):hover {\n      background: rgba(255, 255, 255, 0.95);\n      box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.15);\n      padding-top: 6px;\n      padding-bottom: 4px;\n    }\n\n    &:not([disabled]):active {\n      box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.15);\n      padding-top: 8px;\n      padding-bottom: 2px;\n    }\n\n    &.big {\n      padding: 10px 15px;\n\n      &:not([disabled]):hover {\n        padding-top: 12px;\n        padding-bottom: 8px;\n      }\n\n      &:not([disabled]):active {\n        padding-top: 14px;\n        padding-bottom: 6px;\n      }\n    }\n\n    &.dark {\n      background: hsla(180, 90%, 8%, 0.75);\n      color: white;\n\n      &[disabled] {\n        background: hsla(180, 75%, 40%, 0.75);\n      }\n\n      &:not([disabled]):hover {\n        background: hsla(180, 88%, 14%, 0.6);\n        box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.5);\n      }\n\n      &:not([disabled]):active {\n        box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.5);\n      }\n    }\n\n    &.outline {\n      background: hsla(180, 90%, 8%, 0);\n      color: #e3e3e3;\n      box-shadow: 0 0 0 1px #e3e3e3;\n\n      &[disabled] {\n        color: rgba(227, 227, 227, 0.5);\n        box-shadow: 0 0 0 1px rgba(227, 227, 227, 0.5);\n      }\n\n      &:not([disabled]):hover {\n        color: white;\n        box-shadow: 0 0 0 1px white;\n        background-color: rgba(255, 255, 255, 0.2);\n        padding: 5px 15px;\n      }\n\n      &:not([disabled]):active {\n        box-shadow: 0 0 0 1px #e3e3e3;\n        background: rgba(255, 255, 255, 0.4);\n      }\n    }\n  }\n}\n\n.paper {\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  padding: 50px 50px 25px;\n  box-shadow: 0px 5px 5px 0px #000000bf;\n\n  &.nopadding {\n    padding: 0px;\n  }\n\n  &:before {\n    display: block;\n    position: absolute;\n    content: '';\n    background: rgba(30, 28, 32, 0.75);\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: -1;\n  }\n}\n\n.col {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.row {\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.bottombar {\n  background-color: rgb(22, 22, 22);\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 6px 4px 4px;\n  text-align: right;\n\n  a {\n    display: inline-flex;\n    justify-content: center;\n    font-size: 0.75em;\n    color: white;\n    margin: 0 12px;\n\n    &:hover {\n      color: rgb(105, 224, 145);\n    }\n\n    & > * {\n      margin-right: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
